import CustomSearch from './CustomSearch';

export default CustomSearch;